import { _ } from "core-js"
import Vue from "vue"

/**
 * ======================================================================
 *  STATE
 * ======================================================================
 */

const state = {
    zaps: [],
    logs: [],
    customFields: [],
}

/**
 * ======================================================================
 *  GETTERS
 * ======================================================================
 */

const getters = {
    getZaps: state => {
        return state.zaps
    },
    getLogs: state => {
        return state.logs
    },
    getCustomFields: state => {
        return state.customFields
    },
}

/**
 * ======================================================================
 *  MUTATIONS
 * ======================================================================
 */

const mutations = {
    setZaps(state, data) {
        state.zaps = data
    },
    setCustomFields(state, data) {
        state.customFields = data
    },
    setLogs(state, data) {
        state.logs = data
    },
    createZap(state, data) {
        state.zaps.data.push(data)
    },
    updateZap(state, data) {
        state.zaps.data = state.zaps.data.map(zap => (zap.id == data.id ? { ...zap, ...data } : zap))
    },
    deleteZap(state, data) {
        let key = state.zaps.data.findIndex(zap => zap.id === data.id)
        Vue.delete(state.zaps.data, key);
    },
}

/**
 * ======================================================================
 *  ACTIONS
 * ======================================================================
 */
const actions = {
    setZaps({ dispatch, commit, state }, data) {
        return new Promise((resolve, reject) => {
            axios.post("/api/zapier/get-zaps", data, {headers: {
                Authorization: "Bearer " + $store.getters.token,
            }}).then(response => {
                commit("setZaps", response.data.zaps)
                commit("setCustomFields", response.data.customFields)
                resolve(response)
            })
            .catch(error => {
                reject(error)
            })
        })
    },
    setLogs({ dispatch, commit, state }, data) {
        return new Promise((resolve, reject) => {
            axios.post("/api/zapier/get-logs", data, {headers: {
                    Authorization: "Bearer " + $store.getters.token,
                }}).then(response => {
                    commit("setLogs", response.data)
                    resolve(response)
                })
                .catch(error => {
                    reject(error)
                }
            )
        })
    },
    createZap({ dispatch, commit, state }, data) {
        return new Promise((resolve, reject) => {
            axios.post("/api/zapier/create-zap", data, {headers: {
                Authorization: "Bearer " + $store.getters.token,
            }}).then(response => {
                commit("createZap", response.data)
                dispatch("setLogs", {
                    current_page: state.logs.current_page,
                    per_page: state.logs.per_page,
                })
                resolve(response)
            })
            .catch(error => {
                reject(error)
            })
        })
    },
    updateZap({ dispatch, commit, state }, data) {
        return new Promise((resolve, reject) => {
            axios.post("/api/zapier/update-zap", data, {headers: {
                    Authorization: "Bearer " + $store.getters.token,
                }}).then(response => {
                    commit("updateZap", response.data)
                    dispatch("setLogs", {
                        current_page: state.logs.current_page,
                        per_page: state.logs.per_page,
                    })
                    resolve(response)
                })
                .catch(error => {
                    reject(error)
                }
            )
        })
    },
    deleteZap({ dispatch, commit, state }, data) {
        return new Promise((resolve, reject) => {
            axios.post("/api/zapier/delete-zap", data, {headers: {
                Authorization: "Bearer " + $store.getters.token,
            }}).then(response => {
                commit("deleteZap", data)
                dispatch("setLogs", {
                    current_page: state.logs.current_page,
                    per_page: state.logs.per_page,
                })
                resolve(response)
            })
            .catch(error => {
                reject(error)
            })
        })
    },
    setZapActiveState({ dispatch, commit, state }, data) {
        return new Promise((resolve, reject) => {
            axios.post("/api/zapier/activate-zap", data, {headers: {
                Authorization: "Bearer " + $store.getters.token,
            }})
            .then(response => {
                commit("updateZap", response.data)
                dispatch("setLogs", {
                    current_page: state.logs.current_page,
                    per_page: state.logs.per_page,
                })
                resolve(response)
            })
            .catch(error => {
                reject(error)
            })
        })
    },
    replayZaps({ dispatch, commit, state }, data) {
        return new Promise((resolve, reject) => {
            axios.post("/api/zapier/replay-zaps", data, {headers: {
                Authorization: "Bearer " + $store.getters.token,
            }})
            .then(response => {
                resolve(response)
            })
            .catch(error => {
                reject(error)
            })
        })
    }

}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}
